import { Text, useDisclosure, VStack } from '@chakra-ui/react';
import React from 'react';

import { TypeUtils } from '../../framework/utils/UtilityTypes';
import { useSizeContext } from '../containers/SizeProvider';
import { Formatter } from '../utils/FormatUtils';
import StyledButton from './StyledButton';

/**
 * 日付・案件名エリアプロパティ
 */
type DateMatterProps = {
  /**
   * 顧客名
   */
  customerName?: string;
  /**
   * 日付
   */
  date?: Date;
  dateString?: string;
  disabled?: boolean;
  matterId?: number;
  /**
   * 現場名
   */
  matterName?: string;
};

/**
 * 日付・案件名エリア
 */
const DateMatter: React.FunctionComponent<DateMatterProps> = (props) => {
  const sizes = useSizeContext();
  // const { isOpen, onClose, onOpen } = useDisclosure();

  return (
    <VStack
      alignItems="start"
      fontSize={sizes.fontSize.rawMessage}
      width="full"
    >
      <Text margin="0px !important">
        {TypeUtils.isNonNil(props.date)
          ? Formatter.dateOfWeek(props.date)
          : Formatter.dateOfWeekString(props.dateString)}
      </Text>
      <StyledButton
        colorScheme="black"
        fontSize={sizes.fontSize.rawMessage}
        isDisabled
        margin="0px !important"
        // onClick={() => onOpen()}
        textAlign="left"
        variant="link"
        whiteSpace="normal"
      >
        {props.matterName || '―'}
      </StyledButton>
      <Text margin="0px !important">依頼元: {props.customerName || '―'}</Text>
      {/* <MatterDetailModal
        isOpen={isOpen}
        matterId={props.matterId}
        onClose={onClose}
      /> */}
    </VStack>
  );
};

export default DateMatter;
